import { render, staticRenderFns } from "./synthesisDetail.vue?vue&type=template&id=a444c892&scoped=true&"
import script from "./synthesisDetail.vue?vue&type=script&lang=js&"
export * from "./synthesisDetail.vue?vue&type=script&lang=js&"
import style0 from "./synthesisDetail.vue?vue&type=style&index=0&id=a444c892&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a444c892",
  null
  
)

export default component.exports